import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../../../account/core/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Set headers for all requests
    let headers = new HttpHeaders();
    headers = request.headers.set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Pragma', 'no-cache')
      .set('Cache-control', 'no-cache');

    // Set Authorization header with token if user is logged in
    const token = this.authService.token;
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    if (request.params?.get('isHubUser')) {
      const hubToken = this.authService.hubToken;
      headers = headers.set('Authorization', `Bearer ${hubToken}`);
    }

    // Set Abp-TenantId header with tenant ID if it's available
    const tenantId = this.authService.currentTenantIdValue;
    if (tenantId) {
      headers = headers.set('Abp.TenantId', tenantId.toString());
    }

    request = request.clone({
      headers: headers
    });

    return next.handle(request);
  }
}
